import React from "react";
import AppConstants from "../../constants/AppConstants";
import PreviewArea from "./PreviewArea";
import { useProcessingState } from "../../utils/ProcessingStateUtils";

const PreviewStage = ({ preview, theme, layout }) => {
  const processingState = useProcessingState("preview stage");

  const style = {
    flex: 1,
    position: "relative",
    pointerEvent: "none",
    display: "flex",
    minHeight: 0,
    justifyContent: "center"
  };

  let mobileView = null;
  let desktopView = null;

  switch (layout) {
    case AppConstants.STAGE_VIEW_DESKTOP:
      desktopView = (
        <PreviewArea
          preview={preview}
          theme={theme}
          layout={AppConstants.LAYOUT_DESKTOP}
          processingState={processingState}
        />
      );
      break;
    case AppConstants.STAGE_VIEW_MOBILE:
      mobileView = (
        <PreviewArea
          preview={preview}
          theme={theme}
          layout={AppConstants.LAYOUT_MOBILE}
          processingState={processingState}
        />
      );
      break;
    case AppConstants.STAGE_VIEW_SPLIT:
      mobileView = (
        <PreviewArea
          preview={preview}
          theme={theme}
          layout={AppConstants.LAYOUT_MOBILE}
          width={AppConstants.STAGE_MOBILE_SPLIT_WIDTH}
          processingState={processingState}
        />
      );
      desktopView = (
        <PreviewArea
          preview={preview}
          theme={theme}
          layout={AppConstants.LAYOUT_DESKTOP}
          processingState={processingState}
        />
      );
      break;
    default:
  }

  return (
    <div style={style}>
      {mobileView}
      {desktopView}
    </div>
  );
};

export default PreviewStage;
